import { render, staticRenderFns } from "./Linkedin.vue?vue&type=template&id=1030738a&scoped=true"
import script from "./Linkedin.vue?vue&type=script&lang=js"
export * from "./Linkedin.vue?vue&type=script&lang=js"
import style0 from "./Linkedin.vue?vue&type=style&index=0&id=1030738a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1030738a",
  null
  
)

export default component.exports